<template>
    <fragment>
        <div class="iconBox" v-if="iconIsVisible && !isShopIcon">
            <router-link :event="!disabled ? 'click' : ''" :to="{ name: icon.route }" :class="[{ iconBox__disabled: disabled }, 'iconBox__link']" :target="target">
                <div class="icon-box__container">
                    <div class="iconBox__icon">
                        <img :src="iconUrl" :alt="$t(icon.labelTranslateKey)" class="iconBox__image"/>
                    </div>
                    <p v-html="$t(icon.labelTranslateKey)" class="iconBox__label"></p>
                    <div v-if="counterNumber" class="iconBox__counter" v-text="counterNumber"></div>
                    <div class="icon-box__svg-container">
                    <div v-if="isGiftingIcon && hasGiftingCoupon" class="icon-box__offer-label">
                        <span>
                            <heading :text="$t('GIFTING_OFFER_LABEL')" size="small" />
                            <underline :class="classes"/>
                        </span>
                    </div>
                </div>
                </div>
            </router-link>
        </div>
        <div class="iconBoxShop" v-else>
            <router-link :to="{ name: icon.route }" class="iconBoxShop__link" :target="target">
                <img :src="iconUrl" :alt="icon.label" class="iconBoxShop__image"/>
            </router-link>
        </div>
    </fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';
import { Heading } from '@freddiesflowers/frontend-component-library';
import Underline from '@/assets/underline';

export default {
    name: 'IconBox',
    props: {
        icon: {
            required: true,
            type: Object,
        },
        disabled: {
            required: true,
            type: Boolean,
        },
        hasGiftingCoupon: {
            default: false,
            type: Boolean,
        },
    },
    components: { Fragment, Heading, Underline },
    computed: {
        counterNumber() {
            return this.icon.counterGetterName ? this.$store.getters[this.icon.counterGetterName] : null;
        },
        iconUrl() {
            return this.isShopIcon ? require(`@/assets/images/pages/account/dashboard/${this.icon.image}.svg`) : require(`@/assets/images/pages/account/dashboard/${this.icon.image}.png`);
        },
        iconIsVisible() {
            return this.icon.enabled;
        },
        target() {
            return this.icon.target ? this.icon.target : '_self';
        },
        isShopIcon() {
            return this.icon.label === 'Shop';
        },
        isGiftingIcon() {
            return this.icon.image === 'gift';
        },
        selectedLocale() {
            return this.$root.$i18n.locale.split('-')[1];
        },
        classes() {
            const defaulStyle = 'icon-box__offer-label-underline';
            return `${defaulStyle}--${this.selectedLocale}`;
        },
    },
};
</script>

<style scoped>
    .icon-box__container {
        position: relative;
        padding-top: 20px;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        height: 165px;
    }
    .icon-box__svg-container {
        right: 5px;
        top: 15px;
        position: absolute;
    }
    .icon-box__offer-label {
        position: relative;
        transform: rotate(20deg);
    }
    .icon-box__offer-label-underline--en {
        position: absolute;
        bottom: -10px;
        right: 0px;
        transform: rotate(10deg);
    }
    .icon-box__offer-label-underline--de {
        position: absolute;
        bottom: -15px;
        right: -10px;
        transform: rotate(10deg);
        width: 80px;
        height: 20px;
    }
</style>
